import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosMenuItem,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import { CopyAll, Delete, Edit } from "mosaic-react-icons";
import { handleDeleteTranslationTable } from "../../../../actions/UserActions/DatagridHandleUserActions";
import { handleEditAction } from "./utils";

export default function TranslationTableMoreAction(props) {
    const { i18n, pushModal, pushDialog, reload, deleteTranslationTableAction, pushNotification } =
        useGlobalValue();
    const { value: cell } = props || {};
    const { id } = cell || {};

    return (
        <SovosBox>
            <SovosToolbar
                sx={{
                    backgroundColor: "transparent !important",
                }}
            >
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu>
                        <SovosMenuItem
                            onClick={() => handleEditAction(id, pushModal, i18n, reload)}
                        >
                            <Edit />
                            <SovosTypography variant={"span"}>{i18n`Edit`}</SovosTypography>
                        </SovosMenuItem>

                        <SovosMenuItem
                            onClick={() => handleEditAction(id, pushModal, i18n, reload, true)}
                        >
                            <CopyAll />
                            <SovosTypography variant={"span"}>{i18n`Duplicate`}</SovosTypography>
                        </SovosMenuItem>

                        <SovosMenuItem
                            onClick={() =>
                                handleDeleteTranslationTable(
                                    { deleteTranslationTableAction, id, pushDialog, i18n },
                                    pushNotification,
                                )
                            }
                        >
                            <Delete />
                            <SovosTypography variant={"span"}>{i18n`Delete`}</SovosTypography>
                        </SovosMenuItem>
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>
        </SovosBox>
    );
}
